// extracted by mini-css-extract-plugin
export default {"link":"zO-z","disabled":"AO-z"};